import { useQuery } from "@tanstack/react-query";
import apiDal from "../config/apiDal";
import { Category } from "../types";

type GetReportResponsesParams = {
	locale: string;
	reportId: string;
};

const fetchReportResponses = async (
	locale: string = "en-us",
	reportId: string,
): Promise<
	{
		CategoryDimension: string;
		CategoryDimensionOption: string;
		Value: string | null;
	}[]
> => {
	const response = await apiDal.post("/queries/fetch", {
		query: "getReportDimensionsResponse",
		bind: {
			locale: locale.toLowerCase(),
			report: reportId,
		},
	});

	return response.data.result;
};

export const useGetReportResponses = ({ locale, reportId }: GetReportResponsesParams) => {
	return useQuery<
		{
			CategoryDimension: string;
			CategoryDimensionOption: string;
			Value: string | null;
		}[]
	>({
		queryKey: ["getReportDimensionsResponse", locale, reportId],
		queryFn: () => fetchReportResponses(locale, reportId),
		enabled: !!reportId,
	});
};
